// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const caregiver$ = (state = {}) => get(state, ['caregiver'], {})

export const caregiverProfile$ = createSelector(caregiver$, (caregiver = {}) =>
  get(caregiver, ['profile'], {})
)

export const caregiverUuid$ = createSelector(
  caregiverProfile$,
  (profile = {}) => get(profile, ['uuid'], null)
)

export const caregiverGamificationEnabled$ = createSelector(
  caregiverProfile$,
  (profile = {}) => get(profile, ['gamificationEnabled'], false)
)

export const caregiverIsRpmBillableAutoAssign$ = createSelector(
  caregiverProfile$,
  (profile = {}) => get(profile, ['isRpmBillableAutoAssign'], false)
)
